<template>
    <div class="banner-title">
        <div class="banner-title-wrapper">
            <span
                v-if="data.date"
                class="date"
            >
                {{ data.date }}
            </span>

            <ThTitle
                :tag="data.tag"
                size="LARGE"
            >
                {{ data.bannerTitle }}
            </ThTitle>
        </div>

        <div class="image">
            <CmsImage
                :data="data.image"
                fit="cover"
            />
        </div>

        <div class="banner-title-wrapper">
            <div class="description">
                {{ data.description }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ComponentBannerTitleFragment } from '@/graphql/api'

import CmsImage from '@/components/cms/CmsImage.vue'
import ThTitle from '@/components/ui/title/ThTitle.vue'

defineProps<{
    data: ComponentBannerTitleFragment
}>()
</script>

<style lang="scss" scoped>
.banner-title {
    width: 100%;
    position: relative;

    @include min-width(640) {
        padding: 40px 20px;
    }

    @include min-width(1024) {
        min-height: 450px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
    }

    .banner-title-wrapper {
        padding: 0 20px;

        @include min-width(640) {
            z-index: 3;
            position: relative;
            color: $white;
            padding: 0;
            width: 100%;
        }

        .date {
            font-family: $effra-font-stack;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            display: block;
            margin: 0 0 15px;
            font-weight: 400;
            font-size: 0.8rem;

            @include min-width(640) {
                max-width: 680px;
                margin: 0 auto;
            }
        }

        .description {
            margin: 0 0 20px;

            @include min-width(640) {
                max-width: 680px;
                margin: 0 auto;
            }
        }
    }

    .image {
        width: 100%;
        height: 250px;
        margin: 40px 0;

        @include min-width(640) {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin: 0;

            &::before {
                content: '';
                display: block;
                background: rgba($black, 0.2);
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
            }
        }
    }
}
</style>
